import React from "react";
import styled from "styled-components";
import { DxcBox } from "@dxc-technology/halstack-react";

import { typeface } from "../../common/variables.js";

import reactLogo from "../../common/images/react-brands-color.svg";
import jsLogo from "../../images/js-brands.svg";
// import browser from "../../images/browser_logo.svg";

import { useScreenType } from "../../common/utils";

const tools = [
  {
    logo: jsLogo,
    name: "Halstack Client",
    description:
      "JavaScript library that simplifies the usage of HAL APIs from JS applications, using a more declarative syntax. This library will also help you with the development of such APIs in Node.js.",
    color: "#F7DF1E",
    linkText: "View docs site",
    linkHref: "https://github.com/dxc-technology/halstack-client",
  },
  {
    logo: reactLogo,
    name: "React HAL Components",
    description:
      "A library of reusable React Components and Hooks that takes care of the HAL-related logic. These components use the Halstack Design System and follow DXC Design Guidelines out of the box.",
    linkText: "View docs site",
    color: "#61DAFB",
    linkHref: "https://github.com/dxc-technology/halstack-react-hal",
  },
];

const Tools = () => {
  const screenType = useScreenType();

  return (
    <React.Fragment>
      {screenType !== "desktop" && <ToolBar></ToolBar>}
      <DevToolsContainer screenType={screenType}>
        <ToolsTitle screenType={screenType}>Build HAL APIs and apps</ToolsTitle>
        <DevToolsText>
          <p>
            We have created and published a set of libraries for multiple
            technologies, with the purpose of enabling developers to easilly{" "}
            <b>create HAL APIs</b> of their own, and also{" "}
            <b>develop client applications</b> consuming this type of APIs.
          </p>
          <p>Choose the stack that suits you the best.</p>
        </DevToolsText>
        <DevToolsList className="list">
          {tools.map((tool) => {
            return (
              <DevToolContainer className="container" key={tool.name}>
                <DxcBox shadowDepth={2}>
                  <DevToolContent>
                    <DevToolLogoNameContainer>
                      <DevToolLogo src={tool.logo}></DevToolLogo>
                      <DevToolSeparator color={tool.color}></DevToolSeparator>
                      <DevToolName>{tool.name}</DevToolName>
                    </DevToolLogoNameContainer>
                    <DevToolText>{tool.description}</DevToolText>
                    <DevToolLink>
                      <a href={tool.linkHref}>{tool.linkText}</a>
                    </DevToolLink>
                  </DevToolContent>
                </DxcBox>
              </DevToolContainer>
            );
          })}
        </DevToolsList>
      </DevToolsContainer>

      {/* <ToolsContainer screenType={screenType}>
        <ToolsTitle screenType={screenType}>Explore HAL APIs</ToolsTitle>
        <ToolsList className="list" screenType={screenType}>
          <div className="container" screenType={screenType}>
            <ToolWrapper screenType={screenType}>
              <ToolLogoNameContainer screenType={screenType}>
                <ToolLogo src={browser} screenType={screenType}></ToolLogo>
                <ToolName screenType={screenType}>Halstack Browser</ToolName>
              </ToolLogoNameContainer>
              <ToolText screenType={screenType}>
                <p>
                  Halstack Browser is a web application, also distributed as a
                  React component, that provides a visual mechanism to crawl and
                  discover API resources and operations dynamically for
                  hypermedia-based APIs. Contrary to other path-based approaches
                  such as OpenAPI (where static specs are used to describe a
                  list of pre-defined path resources and available operations).
                </p>
                <p>
                  Halstack Browser allows both API consumers and producers work
                  with auto-discoverable REST APIs just based on their
                  implementations, without any spec. Thus, every time an API
                  implementation changes, these updates will be automatically
                  visible in Halstack Browser Web component without the need of
                  importing or configuring any API spec.
                </p>
              </ToolText>
              <ToolLink screenType={screenType}>
                <a href="https://hal.us.insurance.dxc.com/">
                  Try Halstack Browser
                </a>
              </ToolLink>
            </ToolWrapper>
          </div>
        </ToolsList>
      </ToolsContainer> */}
    </React.Fragment>
  );
};

// const ToolsContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   padding: ${(props) =>
//     props.screenType === "desktop"
//       ? "140px 6% 60px 12%"
//       : props.screenType === "tablet"
//       ? "60px 6% 60px 6%"
//       : "34px 20px 40px 20px"};
//   background-color: #f8f8f8;
// `;

const ToolsTitle = styled.div`
  font-size: ${(props) => (props.screenType !== "mobile" ? "48px" : "34px")};
  margin-bottom: 40px;
`;

// const ToolsList = styled.div`
//   display: flex;
//   flex-direction: ${(props) =>
//     props.screenType === "desktop" ? "row" : "column"};
//   margin-top: 60px;
//   width: 100%;
//   margin-bottom: ${(props) =>
//     props.screenType === "desktop" ? "100px" : "40px"};
//   margin-right: ${(props) => (props.screenType !== "desktop" ? "12%" : "")};
//   margin-left: ${(props) => (props.screenType !== "desktop" ? "12%" : "")};
// `;

// const ToolWrapper = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   height: 100%;
//   align-items: flex-start;
//   background-color: ${(props) =>
//     props.screenType === "tablet" ? "#F5F5F5" : ""};
//   justify-content: ${(props) =>
//     props.screenType !== "desktop" ? "center" : ""};
//   padding: ${(props) => (props.screenType !== "desktop" ? "36px" : "")};
//   ${(props) =>
//     props.screenType === "mobile"
//       ? "border: 1px solid #DBDBDB; border-radius: 12px;"
//       : ""};
// `;

// const ToolLogoNameContainer = styled.div`
//   display: flex;
//   align-items: center;
//   flex-direction: ${(props) =>
//     props.screenType === "mobile" ? "column" : "row"};
//   width: 100%;
//   margin-bottom: 20px;
// `;

// const ToolLogo = styled.img`
//   width: ${(props) => (props.screenType !== "mobile" ? "36px" : "38px")};
//   height: ${(props) => (props.screenType !== "mobile" ? "auto" : "auto")};
//   margin-bottom: ${(props) => (props.screenType === "mobile" ? "24px" : "")};
// `;

// const ToolName = styled.div`
//   font-size: 24px;
//   margin-left: ${(props) => (props.screenType !== "mobile" ? "16px" : "")};
//   overflow: hidden;
//   text-overflow: ellipsis;
//   ${(props) =>
//     props.screenType === "mobile"
//       ? "text-transform: uppercase; font-weight: 700; font-size: 16px"
//       : ""}
// `;

// const ToolText = styled.div`
//   width: 100%;
//   font-size: ${typeface.body.fontSize};
//   letter-spacing: 0.3px;
//   text-transform: ${typeface.body.textTransform};
//   padding-bottom: 16px;
//   overflow: hidden;
//   margin-left: ${(props) => (props.screenType === "desktop" ? "53px" : "")};
//   margin-right: ${(props) => (props.screenType === "desktop" ? "12%" : "")};
//   text-align: ${(props) => (props.screenType === "mobile" ? "justify" : "")};
//   color: ${(props) => (props.screenType === "mobile" ? "#666" : "")};
// `;

// const ToolLink = styled.div`
//   display: flex;
//   align-self: flex-end;
//   margin-left: ${(props) => (props.screenType === "desktop" ? "53px" : "")};
//   a {
//     display: inline-flex;
//     align-items: center;
//     color: #006bf6;
//     font-size: 16px;
//     letter-spacing: 0.49px;
//     text-decoration: none;
//     img {
//       margin-left: 12px;
//     }
//   }
// `;

const ToolBar = styled.div`
  background-color: #000;
  height: 40px;
`;

const DevToolsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: ${(props) =>
    props.screenType === "desktop"
      ? "140px 6% 140px 12%"
      : props.screenType === "tablet"
      ? "60px 6% 60px 6%"
      : "34px 20px 40px 20px"};
`;

const DevToolsText = styled.div`
  max-width: 960px;
  margin: 20px 0px 60px 0px;
`;

const DevToolsList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const DevToolContainer = styled.div`
  width: 300px;
  height: 466px;
  margin-right: 40px;
  margin-bottom: 40px;
`;

const DevToolContent = styled.div`
  background: white;
  padding: 25px 35px;
  height: 410px;
`;

const DevToolLogoNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const DevToolLogo = styled.img`
  width: 41px;
  height: 36px;
  padding-bottom: 23px;
`;

const DevToolSeparator = styled.div`
  height: 77px;
  border: 1px solid ${(props) => props.color};
`;

const DevToolName = styled.div`
  font-size: ${typeface.body.fontSize};
  letter-spacing: ${typeface.body.letterSpacing};
  text-transform: ${typeface.body.textTransform};
  padding-top: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 50px;
`;

const DevToolText = styled.div`
  color: #00000066;
  font-size: ${typeface.altSubtitle.fontSize};
  letter-spacing: ${typeface.altSubtitle.letterSpacing};
  text-transform: ${typeface.altSubtitle.textTransform};
  overflow: hidden;
  height: 180px;
`;

const DevToolLink = styled.div`
  display: flex;
  justify-content: center;
  a {
    color: #2747afde;
    font-size: 13px;
    letter-spacing: 0.17px;
    text-decoration: none;
  }
`;

export default Tools;
